import { action, observable, runInAction, makeObservable } from "mobx";
import SecuritySurveyApi from "../api/SecuritySurveyApi";

import PopupElement from "./models/PopupElement";

import setCookie from "../utils/setCookie";
import getCookie from "../utils/getCookie";

class SecuritySurvey {
  constructor(rootStore) {
    makeObservable(this, {
      show: observable,
      screen: observable,
      ratingValue: observable,
      isWait: observable,
      isError: observable,
      showSecuritySurvey: action,
      close: action,
    });

    this.rootStore = rootStore;
    this.SecuritySurveyApi = new SecuritySurveyApi();

    this.securitySurveyPopup = new PopupElement({
      name: "SecuritySurvey",
      eventType: "internal",
      priority: "important",
      position: "bottomRight",
      openCallback: this.showSecuritySurvey,
      custom: true,
    });
  }

  /** Показываем ли информер */
  show = false;

  /** Какой сейчас экран ("rating" или  "answer") */
  screen = "rating";

  /** Выбранная оценка */
  ratingValue = null;

  /** Ждём ли ответ */
  isWait = false;

  /** Отправили ли оценку */
  isError = false;

  initSecuritySurvey = () => {
    const cookie = getCookie("wasShowedSecuritySurvey");
    const registrationDate = this.rootStore.profile.user.registration_date;

    // Если пользователю еще не показывали опрос о безопасности
    // и дата регистрации больше 180 дней
    if (cookie !== "true" && this.isDateOlderThan180Days(registrationDate)) {
      this.checkIsParticipant();
    } else {
      this.rootStore.nps.initNps();
    }
  };

  checkIsParticipant = () => {
    this.SecuritySurveyApi.getIsParticipant().then(({ data }) => {
      if (data && data.to_show) {
        setTimeout(() => {
          this.rootStore.popupController.addPopupToQueue(
            this.securitySurveyPopup
          );
        }, 3000);
      }
      // Если пользователю не нужно показывать опрос о безопасности, то показываем NPS
      if (data && !data.to_show) {
        this.rootStore.nps.initNps();
      }
    });
  };

  showSecuritySurvey = () => {
    this.show = true;
  };

  close = () => {
    this.show = false;
    this.rootStore.popupController.handlePopupClose(this.securitySurveyPopup);
  };

  /** Отказаться от опроса (На экране rating нажать крестик) */
  sendReject = () => {
    const body = {
      rating: null,
    };

    this.SecuritySurveyApi.sendPoint(JSON.stringify(body));

    this.setWasShowedSecuritySurveyCookie();
  };

  /** Обработчик на бальном круге, который выбрали */
  onRatingClick = (rating) => {
    this.isWait = true;
    this.ratingValue = rating;
    this.isError = false;

    const body = {
      rating,
    };

    this.SecuritySurveyApi.sendPoint(JSON.stringify(body))
      .then(() => {
        runInAction(() => {
          this.isWait = false;
          this.screen = "answer";

          this.setWasShowedSecuritySurveyCookie();
        });
      })
      .catch(() => {
        runInAction(() => {
          this.isWait = false;
          this.isError = true;
        });
      });
  };

  /** Обработчик закрытия информера */
  onClose = () => {
    if (this.screen === "rating") {
      this.sendReject();
    }

    this.close();
  };

  /** Обработчик нажатия на кнопку Отправить */
  onAnswer = (text = null) => {
    this.isWait = true;
    this.isError = false;
    const body = {
      comment: text,
    };

    this.SecuritySurveyApi.sendAnswer(JSON.stringify(body))
      .then(() => {
        runInAction(() => {
          this.isWait = false;
          this.close();
        });
      })
      .catch(() => {
        runInAction(() => {
          this.isError = true;
          this.isWait = false;
        });
      });
  };

  /** Записываем на 5 месяцев в куки, что пользователю показали опрос о безопасности */
  setWasShowedSecuritySurveyCookie = () => {
    setCookie("wasShowedSecuritySurvey", "true", {
      domain: window.location.hostname.replace(/.*(.ati\.s.*)/g, "$1"),
      expires: 152,
    });
  };

  isDateOlderThan180Days = (dateString) => {
    const date = new Date(dateString);
    const now = new Date();
    const diffTime = Math.abs(now - date);
    const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));

    return diffDays > 180;
  };
}

export default SecuritySurvey;
